import { FieldSubType } from "../common/enums/field-sub-type-enum";
import { MultiSelectionType } from "../common/enums/field-type-enum";
import { FieldVisibilityModel } from "../profile-customization/Model/CustomFieldModel";

export class FieldSettings{
  constructor(){
    this.mainDefinitionVisibilityType = '';
    this.submitFrom3Dots = false;
    this.onMainFormListCardVisibility = new FieldVisibilityModel();
    this.multiLookupVisisbityType = '';
    this.lookupViewPermission = '';
    this.identifier = '';
    this.showOnMainform = false;
    this.lookupRelation = '';
    this.lookupCascadeClosureEnabled = false;
    this.subType = null; 
    this.multiSelectType = MultiSelectionType.List;
    this.minEntries = 1;
    this.maxEntries = null;
  }
  
  mainDefinitionVisibilityType: string;
  submitFrom3Dots: boolean;
  onMainFormListCardVisibility: FieldVisibilityModel;
  multiLookupVisisbityType: string;
  lookupViewPermission: string;
  identifier: string;
  showOnMainform: boolean;
  lookupRelation: string;
  lookupCascadeClosureEnabled: boolean;
  subType: FieldSubType;
  multiSelectType: MultiSelectionType;
  minEntries?: number | null;
  maxEntries?: number | null;

  static coerceEntryCount(value: any, fallback: number | null): number | null {
    if (value === '' || value == null) {
      return fallback;
    }
    const numericValue = Number(value);
    return isNaN(numericValue) ? fallback : numericValue;
  }

  /** Copies the multi-entry limits stored in field.settings onto the field itself. */
  static applyEntryLimits(field: any): void {
    if (!field?.settings) {
      return;
    }
    ['minEntries', 'maxEntries'].forEach(key => {
      const setting = field.settings.find((s: any) => s.key?.toLowerCase() == key.toLowerCase());
      if (setting) {
        field[key] = FieldSettings.coerceEntryCount(setting.value, key === 'minEntries' ? 1 : null);
      }
    });
  }
}
